// @ts-nocheck
import type NavigationType from '@rover/reactNativeApp/src/bridges/navigation';

const Navigation: typeof NavigationType = {};

export default Navigation;
